import React, { Fragment } from "react";

import { generatePath, matchPath, NavLink, Outlet, useLocation } from "react-router-dom";

import { ButtonNavigation } from "../../../../../common/components/Navigation/ButtonNavigation/ButtonNavigation.styles";
import { Spinner } from "../../../../../common/components/Spinner/Spinner";
import { Workspace } from "../../../../../common/models";
import { useAppSelectionContext } from "../../../../context/App/AppSelectionContext";
import { infoHowToRouteConfigs, PathRouteConfig, RouteConfigType } from "../../../../router/config/routesConfig";

export const InfoHowToModule = () => {
  const { selectedWorkspace } = useAppSelectionContext();
  const location = useLocation();

  if (!selectedWorkspace) {
    return <Spinner />;
  }

  const howToLinks = infoHowToRouteConfigs
    .filter((routeConfig) => routeConfig.type === RouteConfigType.PATH)
    .map((pathRouteConfig) => {
      const config = pathRouteConfig as PathRouteConfig;
      return mapRouteConfigToNavLink(config, selectedWorkspace, !!matchPath(config.path, location.pathname));
    });

  return (
    <Fragment>
      <ButtonNavigation>{howToLinks}</ButtonNavigation>

      <Outlet />
    </Fragment>
  );
};

const mapRouteConfigToNavLink = (config: PathRouteConfig, workspace: Workspace, isActive: boolean) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const to = generatePath(config.path, { workspaceSlug: workspace.slug ?? null });

  return (
    <div
      className={isActive ? "active" : ""}
      key={config.name}
    >
      <NavLink
        to={to}
        data-testid={config.testId}
      >
        {config.name}
      </NavLink>
    </div>
  );
};
